import dataUtils from "@/utils/data";
export default class Funcionario {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    this.nome = obj.nome;
    this.login = obj.login;
    this.codigo = obj.codigo;
    this.email = obj.email;
    this.dataAdmissao = obj.dataAdmissao;
    this.dataDesligamento = obj.dataDesligamento;
    this.codigoDepartamento = obj.codigoDepartamento;
    this.codigoEmpresa = obj.codigoEmpresa;
    this.nomeDepartamento = obj.nomeDepartamento;
    this.idSetor = obj.idSetor;
    this.selecionado = false;
  }

  aplicarMascaraData() {
    this.dataAdmissao = dataUtils.aplicarMascaraEmDataIso(this.dataAdmissao);
    this.dataDesligamento = dataUtils.aplicarMascaraEmDataIso(
      this.dataDesligamento
    );
  }
}
